import View from './components';
import { REDUCER_KEY } from './constants';
import reducers from './reducers';
import sagas from './sagas';

export const genericReducers = reducers;
export const genericSagas = sagas;
export const GenericReporting = View;
export const GENERIC_REDUCER_KEY = REDUCER_KEY;
